<script>
import RepairFileService from '@/services/RepairFileService'
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'

export default {
  name: 'EstimatePackageClientOptionSelected',
  data() {
    return {
      created: false,
      loading: false,
      tokenValidity: false,
      logoPath: null,
      networkPrimaryColor: null,
      token: '',
      showButton: true,
      showForm: false,

      purchaseOrderAttachmentToken: null,
      orderNumber: null,
      callbackRef: null,

      file: null,

      formValid: false,

      error: null
    }
  },
  async created() {
    this.loading = true

    this.$store.dispatch('auth/cleanSession')
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')
    const option = urlParams.get('option')
    try {
      const response = await RepairFileService.saveClientOptionChoice(option, token)
      this.logoPath = response.logoPath
      this.networkPrimaryColor = response.networkPrimaryColor
      this.purchaseOrderAttachmentToken = response.purchaseOrderAttachmentToken
      this.tokenValidity = true
    } catch (error) {
      handleResponseError(error)
    } finally {
      this.loading = false
    }

    this.created = true
  },
  methods: {
    show() {
      this.showForm = true
    },
    async addPurchaseOrder() {
      this.loading = true

      try {
        let data = {
          orderNumber: this.orderNumber,
          callbackRef: this.callbackRef,
          token: this.purchaseOrderAttachmentToken
        }

        if (this.file) {
          const formData = new FormData()
          formData.append('data', JSON.stringify(data))
          formData.append('file', this.file)
          await RepairFileService.addPurchaseOrderAttachment(formData)
        } else {
          await RepairFileService.addPurchaseOrderAttachment(data)
        }

        this.showForm = false
        this.showButton = false
        displayToast(this.$t('PUBLIC.OPTION.SUCCESS_EMAIL_SEND_WITH_ATTACHMENT'), 'success')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <v-app>
    <v-main v-if="created" class="main">
      <div v-if="tokenValidity" class="container">
        <!--LOGO-->
        <div class="picture-content">
          <v-img :src="logoPath" />
        </div>

        <div class="title">
          <div>
            {{ $t('PUBLIC.ESTIMATE_PACKAGE_CLIENT_OPTION.TITLE') }}
          </div>
          <div class="message">
            {{ $t('PUBLIC.ESTIMATE_PACKAGE_CLIENT_OPTION.MESSAGE') }}
          </div>
        </div>

        <div v-if="!showForm && showButton" class="message-container">
          <div class="purchase-order-message">
            {{ $t('PUBLIC.ESTIMATE_PACKAGE_CLIENT_OPTION.PURCHASE_ORDER_MESSAGE') }}
          </div>
        </div>

        <div v-if="!showForm && showButton" class="toggle-container">
          <div class="toggle-sub-container">
            <v-icon icon="mdi-download" />
            <div class="toggle-text" @click="show()">
              {{ $t('PUBLIC.ESTIMATE_PACKAGE_CLIENT_OPTION.TOGGLE_TEXT') }}
            </div>
            <div class="toggle-message">
              {{ $t('PUBLIC.ESTIMATE_PACKAGE_CLIENT_OPTION.TOGGLE_MESSAGE') }}
            </div>
          </div>
        </div>

        <!--Purchase order-->
        <div v-if="showForm" class="message-container">
          <div class="purchase-order-form">
            {{ $t('PUBLIC.ESTIMATE_PACKAGE_CLIENT_OPTION.PURCHASE_ORDER_FORM_MESSAGE') }}
          </div>
        </div>

        <v-container v-if="showForm" class="form-container">
          <v-form ref="formAddPurchaseOrder" @submit.prevent="addPurchaseOrder" v-model="formValid">
            <!--Order number-->
            <v-row justify="center">
              <v-col col="6" md="6" lg="6" xl="6">
                <p data-rgpd="true" class="content-title">
                  {{ $t('PUBLIC.ESTIMATE_PACKAGE_CLIENT_OPTION.FORM.ORDER_NUMBER') }}
                </p>
                <v-text-field
                  v-model="orderNumber"
                  :error-messages="error?.orderNumber"
                  :hide-details="!error?.orderNumber"
                  required
                />
              </v-col>
            </v-row>

            <!--Callback ref-->
            <v-row justify="center">
              <v-col col="6" md="6" lg="6" xl="6">
                <p class="content-title">
                  {{ $t('PUBLIC.ESTIMATE_PACKAGE_CLIENT_OPTION.FORM.CALLBACK_REF') }}
                </p>
                <v-text-field
                  v-model="callbackRef"
                  :error-messages="error?.callbackRef"
                  :hide-details="!error?.callbackRef"
                  required
                />
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col col="6" md="6" lg="6" xl="6">
                <!--Add attachment-->
                <p class="mb-2">
                  {{ $t('PUBLIC.ESTIMATE_PACKAGE_CLIENT_OPTION.FORM.ATTACHMENT') }}
                </p>
                <v-file-input
                  class="logo-selector"
                  chips
                  counter
                  show-size
                  accept=".pdf, .jpg, .png"
                  v-model="file"
                >
                  <template v-slot:append-inner>
                    <img
                      alt="download.svg"
                      class="download-svg mr-4"
                      src="@/assets/icons/file/download.svg"
                    />
                  </template>
                </v-file-input>
              </v-col>
            </v-row>

            <div class="btn-container">
              <v-btn
                class="public-boom-button"
                :style="{ background: networkPrimaryColor ? networkPrimaryColor : '#559a1b' }"
                :disabled="loading || !formValid"
                :loading="loading"
                variant="outlined"
                type="submit"
              >
                {{ $t('COMMON.BUTTON.SEND') }}
              </v-btn>
            </div>
          </v-form>
        </v-container>
      </div>

      <div v-if="!tokenValidity" class="container">
        <div class="mt-6 pa-4">
          <img src="@/assets/images/boomerang_black_logo.svg" alt="boomerang logo" class="mb-4" />

          <h2 class="font-weight-bold mb-5 d-flex justify-center">
            {{ $t('REPAIR_FILE_PROSPECT_ADD_PICTURE.TITLE_ERROR_TOKEN_VALIDITY') }}
          </h2>
          <div class="mb-5">
            <p class="mb-5">
              {{ $t('REPAIR_FILE_PROSPECT_ADD_PICTURE.MESSAGE_ERROR_TOKEN_VALIDITY') }}
            </p>
          </div>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.title {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  font-size: x-large;
  font-weight: bold;
  font-family: 'Roboto', serif;
  align-content: center;
  margin: 10px auto 10px auto;
}

.message-container {
  display: flex;
  flex-direction: row;
  font-size: x-large;
  font-weight: bold;
  font-family: 'Roboto', serif;
  justify-content: center;
  flex-wrap: nowrap;
  align-content: center;
  align-items: flex-start;
}

.btn-container {
  display: flex;
  flex-direction: row;
  font-size: x-large;
  font-weight: bold;
  font-family: 'Roboto', serif;
  justify-content: center;
  flex-wrap: nowrap;
  align-content: center;
  align-items: flex-start;
}

.form-container {
  font-family: 'Roboto', serif;
}

.message {
  display: flex;
  flex-direction: row;
  font-size: x-large;
  font-family: 'Roboto', serif;
  justify-content: center;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
}

.purchase-order-message {
  display: flex;
  flex-direction: row;
  font-size: large;
  font-family: 'Roboto', serif;
  justify-content: center;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  padding: 12px;
  margin: 10vh auto auto auto;
}

.purchase-order-form {
  display: flex;
  flex-direction: row;
  font-size: large;
  font-family: 'Roboto', serif;
  justify-content: center;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  padding: 12px;
}

.picture-content {
  margin: 10vh auto auto;
  width: 100%;
  height: 100%;
  max-width: 150px;
}

:deep(.logo-selector .v-field.v-field--appended) {
  justify-content: center !important;
  align-content: center;
}

.download-svg {
  height: 20px;
  filter: invert(98%) sepia(0%) saturate(1853%) hue-rotate(181deg) brightness(96%) contrast(80%);
}

.public-boom-button {
  display: flex !important;
  color: white !important;
  padding: 35px 20px !important;
  border-radius: 20px !important;
  align-items: center !important;
  text-transform: unset !important;
}

.toggle-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.toggle-sub-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  border: solid 1px white;
  background-color: white;
  border-radius: 20px;
  padding: 10px;
}

.toggle-text {
  margin: 0 20px 0 5px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
}

.toggle-message {
  color: #7f7f7f;
}
</style>
